import CustomDatePicker from 'Components/CustomDatePicker'
import Box from '@mui/material/Box'
import { t } from 'ttag'

interface DateRangePickerProps {
  fromDate: string | undefined
  toDate: string | undefined
  onChange: (value: Date | null, name: string) => void
}

export default function DateRangePicker({
  fromDate,
  toDate,
  onChange
}: Readonly<DateRangePickerProps>) {
  return (
    <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
      <CustomDatePicker
        onChange={onChange}
        name="from_date"
        value={fromDate ? new Date(fromDate) : null}
        dateToCompare={toDate ? new Date(toDate) : null}
        dateToCompareFieldName="to_date"
        isStartDate={true}
        label={t`Start date`}
      />
      <Box>{` - `}</Box>
      <CustomDatePicker
        onChange={onChange}
        name="to_date"
        value={toDate ? new Date(toDate) : null}
        dateToCompare={fromDate ? new Date(fromDate) : null}
        dateToCompareFieldName="from_date"
        isStartDate={false}
        label={t`End date`}
      />
    </Box>
  )
}
